// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * v13+ Menu UI standard ("FAANG card" style).
 *
 * Opt-in per menu: add the \`kt-ui-v13\` marker class to the side-menu root
 * element. Everything here is scoped under \`.kt-ui-v13\`, so legacy (pre-v13)
 * menus are untouched until they migrate. The marker class is also the flag the
 * migration tracker uses to mark a menu as "on the v13+ UI" — see CLAUDE.md and
 * docs-local/ui/v13-menu-style.md.
 *
 * Building blocks (compose inside a \`.kt-ui-v13\` menu):
 *   .kt-section        titled card grouping one family of controls
 *   .kt-section-label  small uppercase section label (use a <div>, NOT an h5 —
 *                      the side-menu pipeline strips the first center-aligned h5)
 *   .kt-divider        full-bleed hairline separating sub-groups in a card
 *   .kt-field-row      row of side-by-side form fields (Materialize input-fields)
 *   .kt-action         full-width action row (label left, chevron right)
 *   .kt-action-label   the label span inside a .kt-action button
 */

/* ===== Tab row: recessed segmented control ===== */
.kt-ui-v13 .tabs {
  display: flex;
  gap: 4px;
  height: auto;
  padding: 4px;
  margin-bottom: 4px;
  background-color: rgba(0, 0, 0, 0.28);
  border: 1px solid var(--color-dark-border);
  border-radius: var(--kt-radius-md, 6px);
  overflow: visible;
}

.kt-ui-v13 .tabs .tab {
  flex: 1 1 0;
  height: auto;
  line-height: normal;
}

/* Override Materialize's grid width (the tabs are emitted as \`.col sN\`). */
.kt-ui-v13 .tabs .tab.col {
  width: auto;
  padding: 0;
}

.kt-ui-v13 .tabs .tab a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  text-align: center;
  border-radius: var(--kt-radius-sm, 4px);
  background-color: rgba(255, 255, 255, 0.06);
  /* !important overrides the global \`a { color: accent !important }\` rule. */
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.kt-ui-v13 .tabs .tab a:hover {
  background-color: rgba(255, 255, 255, 0.12);
  color: var(--color-text-light, #f5f5f5) !important;
}

.kt-ui-v13 .tabs .tab a:focus,
.kt-ui-v13 .tabs .tab a:focus.active {
  background-color: rgba(255, 255, 255, 0.12);
}

.kt-ui-v13 .tabs .tab a.active,
.kt-ui-v13 .tabs .tab a.active:focus {
  background-color: var(--color-primary, #ba160c);
  color: #fff !important;
}

/* The segmented active-fill replaces the sliding underline. */
.kt-ui-v13 .tabs .indicator {
  display: none;
}

/* ===== Section card ===== */
.kt-ui-v13 .kt-section {
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid var(--color-dark-border);
  border-radius: var(--kt-radius-lg, 8px);
  padding: 12px 14px 14px;
  margin: 0 6px 12px;
}

.kt-ui-v13 .kt-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-dark-text-muted);
  margin: 0 0 8px;
}

/* A Materialize <select>'s popup (.dropdown-content, z-index 9999) is a
   descendant of its card. With the card at the default \`z-index: auto\`, that
   inner z-index only competes inside the card's own stacking context, so a
   LATER sibling card (also auto) paints over the open dropdown - its labels and
   toggles bleed through the popup. Promote the card holding the OPEN dropdown to
   its own stacking context so the popup clears the cards stacked below it.

   \`.kt-dropdown-open\` is toggled by the FormSelect open/close callbacks in
   material-select.ts (added at open-START, removed at close-END), so it stays
   true for the entire open + ~250ms close-fade window and clears the moment the
   popup is actually hidden - the same lifecycle the dropdown's inline
   \`display: block\` had, but WITHOUT a
   \`:has(.dropdown-content[style*="display: block"])\` rule. That \`:has()\` matched
   on the \`style\` attribute, which forced Chrome to re-run a full-document style
   recalc on every style-attribute mutation anywhere on the page (the timeline
   playhead alone moves every frame), tanking the frame rate. A plain class keys
   the promotion off infrequent class changes instead. (\`:focus-within\` can't be
   used: Materialize flips focus at close-START, which would drop the z-index
   during the fade and re-expose the cards behind.) */
.kt-ui-v13 .kt-section.kt-dropdown-open {
  position: relative;
  z-index: 5;
}

/* Full-bleed hairline between sub-groups within a card. */
.kt-ui-v13 .kt-divider {
  height: 1px;
  margin: 14px -14px;
  background: var(--color-dark-border);
}

/* Muted explanatory note inside a section card. */
.kt-ui-v13 .kt-note {
  font-size: 12px;
  line-height: 1.4;
  color: var(--color-dark-text-muted);
  margin: 0 0 8px;
}

/* ===== Field rows ===== */
.kt-ui-v13 .kt-field-row {
  display: flex;
  gap: 12px;
  margin: 0;
}

.kt-ui-v13 .kt-field-row .input-field.col {
  width: auto;
  flex: 1 1 0;
  float: none;
  margin: 6px 0 0;
  padding: 0;
}

/* ===== Action rows ===== */
.kt-ui-v13 .kt-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 14px;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--color-dark-border);
  border-radius: var(--kt-radius-md, 6px);
  color: var(--color-text-light, #f5f5f5);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  text-transform: none;
  letter-spacing: 0;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.kt-ui-v13 .kt-action:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: var(--color-primary-light, #e01a0e);
}

.kt-ui-v13 .kt-action::after {
  content: '\\203A'; /* › */
  margin-left: 12px;
  font-size: 18px;
  line-height: 1;
  color: var(--color-dark-text-muted);
  transition: transform 0.15s ease, color 0.15s ease;
}

.kt-ui-v13 .kt-action:hover::after {
  color: var(--color-text-light, #f5f5f5);
  transform: translateX(2px);
}

.kt-ui-v13 .kt-action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.kt-ui-v13 .kt-action:disabled:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: var(--color-dark-border);
}

.kt-ui-v13 .kt-action:disabled::after {
  display: none;
}

.kt-ui-v13 .kt-action-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/engine/ui/menu-v13.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF,oDAAoD;AACpD;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,2EAA2E;EAC3E,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;qDAkBqD;AACrD;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB,EAAE,MAAM;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["/**\n * v13+ Menu UI standard (\"FAANG card\" style).\n *\n * Opt-in per menu: add the `kt-ui-v13` marker class to the side-menu root\n * element. Everything here is scoped under `.kt-ui-v13`, so legacy (pre-v13)\n * menus are untouched until they migrate. The marker class is also the flag the\n * migration tracker uses to mark a menu as \"on the v13+ UI\" — see CLAUDE.md and\n * docs-local/ui/v13-menu-style.md.\n *\n * Building blocks (compose inside a `.kt-ui-v13` menu):\n *   .kt-section        titled card grouping one family of controls\n *   .kt-section-label  small uppercase section label (use a <div>, NOT an h5 —\n *                      the side-menu pipeline strips the first center-aligned h5)\n *   .kt-divider        full-bleed hairline separating sub-groups in a card\n *   .kt-field-row      row of side-by-side form fields (Materialize input-fields)\n *   .kt-action         full-width action row (label left, chevron right)\n *   .kt-action-label   the label span inside a .kt-action button\n */\n\n/* ===== Tab row: recessed segmented control ===== */\n.kt-ui-v13 .tabs {\n  display: flex;\n  gap: 4px;\n  height: auto;\n  padding: 4px;\n  margin-bottom: 4px;\n  background-color: rgba(0, 0, 0, 0.28);\n  border: 1px solid var(--color-dark-border);\n  border-radius: var(--kt-radius-md, 6px);\n  overflow: visible;\n}\n\n.kt-ui-v13 .tabs .tab {\n  flex: 1 1 0;\n  height: auto;\n  line-height: normal;\n}\n\n/* Override Materialize's grid width (the tabs are emitted as `.col sN`). */\n.kt-ui-v13 .tabs .tab.col {\n  width: auto;\n  padding: 0;\n}\n\n.kt-ui-v13 .tabs .tab a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  line-height: 32px;\n  padding: 0 12px;\n  text-align: center;\n  border-radius: var(--kt-radius-sm, 4px);\n  background-color: rgba(255, 255, 255, 0.06);\n  /* !important overrides the global `a { color: accent !important }` rule. */\n  color: rgba(255, 255, 255, 0.6) !important;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: none;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.kt-ui-v13 .tabs .tab a:hover {\n  background-color: rgba(255, 255, 255, 0.12);\n  color: var(--color-text-light, #f5f5f5) !important;\n}\n\n.kt-ui-v13 .tabs .tab a:focus,\n.kt-ui-v13 .tabs .tab a:focus.active {\n  background-color: rgba(255, 255, 255, 0.12);\n}\n\n.kt-ui-v13 .tabs .tab a.active,\n.kt-ui-v13 .tabs .tab a.active:focus {\n  background-color: var(--color-primary, #ba160c);\n  color: #fff !important;\n}\n\n/* The segmented active-fill replaces the sliding underline. */\n.kt-ui-v13 .tabs .indicator {\n  display: none;\n}\n\n/* ===== Section card ===== */\n.kt-ui-v13 .kt-section {\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid var(--color-dark-border);\n  border-radius: var(--kt-radius-lg, 8px);\n  padding: 12px 14px 14px;\n  margin: 0 6px 12px;\n}\n\n.kt-ui-v13 .kt-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-dark-text-muted);\n  margin: 0 0 8px;\n}\n\n/* A Materialize <select>'s popup (.dropdown-content, z-index 9999) is a\n   descendant of its card. With the card at the default `z-index: auto`, that\n   inner z-index only competes inside the card's own stacking context, so a\n   LATER sibling card (also auto) paints over the open dropdown - its labels and\n   toggles bleed through the popup. Promote the card holding the OPEN dropdown to\n   its own stacking context so the popup clears the cards stacked below it.\n\n   `.kt-dropdown-open` is toggled by the FormSelect open/close callbacks in\n   material-select.ts (added at open-START, removed at close-END), so it stays\n   true for the entire open + ~250ms close-fade window and clears the moment the\n   popup is actually hidden - the same lifecycle the dropdown's inline\n   `display: block` had, but WITHOUT a\n   `:has(.dropdown-content[style*=\"display: block\"])` rule. That `:has()` matched\n   on the `style` attribute, which forced Chrome to re-run a full-document style\n   recalc on every style-attribute mutation anywhere on the page (the timeline\n   playhead alone moves every frame), tanking the frame rate. A plain class keys\n   the promotion off infrequent class changes instead. (`:focus-within` can't be\n   used: Materialize flips focus at close-START, which would drop the z-index\n   during the fade and re-expose the cards behind.) */\n.kt-ui-v13 .kt-section.kt-dropdown-open {\n  position: relative;\n  z-index: 5;\n}\n\n/* Full-bleed hairline between sub-groups within a card. */\n.kt-ui-v13 .kt-divider {\n  height: 1px;\n  margin: 14px -14px;\n  background: var(--color-dark-border);\n}\n\n/* Muted explanatory note inside a section card. */\n.kt-ui-v13 .kt-note {\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--color-dark-text-muted);\n  margin: 0 0 8px;\n}\n\n/* ===== Field rows ===== */\n.kt-ui-v13 .kt-field-row {\n  display: flex;\n  gap: 12px;\n  margin: 0;\n}\n\n.kt-ui-v13 .kt-field-row .input-field.col {\n  width: auto;\n  flex: 1 1 0;\n  float: none;\n  margin: 6px 0 0;\n  padding: 0;\n}\n\n/* ===== Action rows ===== */\n.kt-ui-v13 .kt-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 40px;\n  padding: 0 14px;\n  margin-top: 8px;\n  position: relative;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--color-dark-border);\n  border-radius: var(--kt-radius-md, 6px);\n  color: var(--color-text-light, #f5f5f5);\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  text-transform: none;\n  letter-spacing: 0;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.kt-ui-v13 .kt-action:hover {\n  background: rgba(255, 255, 255, 0.09);\n  border-color: var(--color-primary-light, #e01a0e);\n}\n\n.kt-ui-v13 .kt-action::after {\n  content: '\\203A'; /* › */\n  margin-left: 12px;\n  font-size: 18px;\n  line-height: 1;\n  color: var(--color-dark-text-muted);\n  transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.kt-ui-v13 .kt-action:hover::after {\n  color: var(--color-text-light, #f5f5f5);\n  transform: translateX(2px);\n}\n\n.kt-ui-v13 .kt-action:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.kt-ui-v13 .kt-action:disabled:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: var(--color-dark-border);\n}\n\n.kt-ui-v13 .kt-action:disabled::after {\n  display: none;\n}\n\n.kt-ui-v13 .kt-action-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
